import React from 'react'
import Modal from 'react-modal'
import styles from './emailSenderModal.scss'
import EmailSenderModal from './emailSenderModal'
import underscore from 'underscore'
import nesProp from 'nested-property'

import { getEmailTemplate, showEmailSenderModal, loadSignatures, getInvitationTemplates } from 'state/actions'
import { connect } from 'react-redux'
import c from 'state/constants'

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

@connect((state) => ({
    modalIsOpen: state.emailSender.emailModalIsOpen,
    moduleKey: state.emailSender.moduleKey,
    EmailTemplateRelations: state.app.security.EmailTemplateRelations,
    contractManagerLanguage: state.contracts.contractManagerLanguage,
    contractManagerMail: state.contracts.contractManagerMail,
    claimsManagersDetails: state.clients.claimsManagersDetails,
    claimsManagers: state.app.claimsManagersDetails,
}))
export default class EmailSender extends React.Component {
    static propTypes = {
        dispatch: React.PropTypes.func.isRequired,
        modalIdOpened: React.PropTypes.any,
        moduleKey: React.PropTypes.string.isRequired,
        moduleOptions: React.PropTypes.object,
        contractManagerLanguage: React.PropTypes.string,
        contractManagerMail: React.PropTypes.string,
        claimsManagersDetails: React.PropTypes.array,
        claimsManagers: React.PropTypes.array,
        modalId: React.PropTypes.string,
        onSent: React.PropTypes.func,
        onSentLate: React.PropTypes.func,
        hideCC: React.PropTypes.bool,
        multiLanguage: React.PropTypes.bool,
        serialSending: React.PropTypes.bool,
        getDSStakeholders: React.PropTypes.func,
        isCreatable: React.PropTypes.bool,
        forceIsMulti: React.PropTypes.bool,
        onCancel: React.PropTypes.func,
        forceOpen: React.PropTypes.bool,
    }

    constructor(props) {
        super(props)

        this.state = {
            templates: null,
            signatures: null,
            recipientWillemotEmails: null
        }
    }

    async componentDidMount() {
        let { moduleKey, dispatch, moduleOptions } = this.props
        let moduleRelated = await this.processModuleKey(
            moduleKey,
            nesProp.get(moduleOptions, "dsPackage._id"),
            nesProp.get(moduleOptions, "stakeholders")
        )
        let signaturesResponse = await dispatch(loadSignatures())

        this.setState({
            templates: moduleRelated.templates,
            recipientWillemotEmails: moduleRelated.recipientWillemotEmails,
            signatures: signaturesResponse.signatures
        }, () => {
            dispatch(showEmailSenderModal())
        })

        /*  let whiteListRecipients = [];
         const clientProfileKey = nesProp.get(EmailTemplateRelations, "recipientsWithModules") || false
 
         // TODO compose enabled recipient list after module
         switch( moduleKey ) {
             case 'balh': {
                 whiteListRecipients = []
                 break
             }
             default:
 
         }  */
        // const EmailTemplateRelations
    }

    /**
     *
     * @param {*} nextProps
     */
    async componentWillReceiveProps(nextProps) {
        let { dispatch, moduleOptions } = this.props

        if (this.props.moduleKey !== nextProps.moduleKey) {
            let moduleRelated = await this.processModuleKey(
                nextProps.moduleKey,
                nesProp.get(moduleOptions, "dsPackage._id"),
                nesProp.get(moduleOptions, "stakeholders")
            )

            this.setState({
                templates: moduleRelated.templates,
                recipientWillemotEmails: moduleRelated.recipientWillemotEmails,
            }, () => {
                dispatch(showEmailSenderModal())
            })
        }
    }

    /**
     * This function determine the list of templates available and the recipients list for emailer.
     * @param {*} moduleKey
     * @param {*} packageId
     * @param {*} stakeholders
     * @returns
     */
    async processModuleKey(moduleKey, packageId = null, stakeholders = null) {
        const { dispatch, moduleOptions, EmailTemplateRelations } = this.props

        // check required args
        if (!moduleKey) {
            return {
                templates: [],
                recipientWillemotEmails: []
            }
        }

        //let moduleKeyOfMifid = nesProp.get(this.props, "EmailTemplateRelations.EmailTemplateModules.mifid.value")
        let templates = []
        let recipientWillemotEmails = []

        // if the email is opened from emailer, can be determined by this parameters
        if (packageId && stakeholders) {
            let templateResponse = await dispatch(getInvitationTemplates(moduleKey, packageId))

            templates = templateResponse && templateResponse.templates || []

            //determine if there is a form filler and status for form filling is Available and for signing is Waiting
            const formFiller = stakeholders.find(oneStakeholder => {
                return oneStakeholder.roles.find(oneRole => oneRole.type === 'formFiller' && oneRole.status === 'Available')
            })

            if (formFiller) {
                recipientWillemotEmails = [{
                    email: formFiller.email,
                    name: {
                        first: formFiller.firstName,
                        last: formFiller.lastName
                    },
                    language: formFiller.language
                }]
            } else {
                recipientWillemotEmails = stakeholders.map((oneStake) => {
                    return {
                        email: oneStake.email,
                        name: {
                            first: oneStake.firstName,
                            last: oneStake.lastName
                        },
                        language: oneStake.language
                    }

                })
            }

        }

        // Any other normal case get templates by moduleKey
        else {
            // by default is the module where was opened the emailsender mdoal !!!BUT!!!,
            // there are special cases when the emailer is opened on contract/tarif/claim but started from inbox-quick-reply
            // that require separate special template BEWB-730 as quick reply template
            let moduleKeyForTempalteFetch = moduleKey

            if (moduleOptions && moduleOptions.startedFromModule == c.EMAILER_MODAL_INBOX_REPLY_TO_WILLEMOT &&
                moduleOptions.quickReply) {
                moduleKeyForTempalteFetch = EmailTemplateRelations.EmailTemplateModules.inboxReplyToWillemot.value
            }

            let templateResponse = await dispatch(getEmailTemplate(moduleKeyForTempalteFetch))

            templates = templateResponse && templateResponse.templates || []
            recipientWillemotEmails = templateResponse && templateResponse.recipientWillemotEmails || []
        }

        return {
            templates,
            recipientWillemotEmails
        }
    }

    render() {
        const { onSent, onSentLate, modalId, modalIsOpen, hideCC, forceOpen } = this.props
        const { templates, signatures, recipientWillemotEmails } = this.state
        return (
            <div key={"EmailSenderModal" + modalId + "key"}>
                <Modal
                    isOpen={!!modalIsOpen || !!forceOpen}
                    style={customStyles}
                    className={styles.modal}
                    contentLabel={""}
                >
                    {templates &&
                        <EmailSenderModal
                            {...this.props}
                            modalId={modalId}
                            moduleOptions={this.props.moduleOptions}
                            templates={templates}
                            recipientWillemotEmails={recipientWillemotEmails}
                            signatures={signatures}
                            onSent={onSent}
                            onSentLate={onSentLate}
                            hideCC={hideCC}
                            multiLanguage={this.props.multiLanguage}
                            serialSending={this.props.serialSending}
                            getDSStakeholders={this.props.getDSStakeholders}
                            isCreatable={this.props.isCreatable}
                            forceIsMulti={this.props.forceIsMulti}
                            onCancel={this.props.onCancel}
                        />
                    }
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/emailSender/index.jsx